module.exports = __webpack_public_path__ + "static/img/earn-big.d9d310d2.png";